import React from "react";
import { Button } from "../components/ui/button";
import { Sparkles } from "lucide-react";

function Treatments() {
  const services = [
    {
      name: "Ansiktsbehandlingar",
      description: "Skräddarsydda ansiktsbehandlingar för alla hudtyper som ger din hud den vård den förtjänar"
    },
    {
      name: "Plasma Pen",
      description: "Plasma Pen är en modern teknologi som lyfter hängande ögonlock utan kirurgi och kan även användas för skonsam borttagning av olika godartade hudförändringar som skin tags, milier, vårtor, seborroiska keratoser, små pigmentfläckar."
    },
    {
      name: "Microneedling",
      description: "Stimulerar hudens egen kollagenproduktion för en fastare och jämnare hud"
    },
    {
      name: "RF Microneedling",
      description: "RF Microneedling kombinerar mikronålning och radiofrekvensenergi för att effektivt förbättra tecken på åldrande hud, bristningar och ärr, och ge huden en fastare och mer ungdomlig struktur."
    },
    {
      name: "Massage",
      description: "Avkopplande och terapeutiska massagebehandlingar för kropp och själ"
    },
    {
      name: "Kosmetisk Tatuering",
      description: "Semipermanent makeup för ögonbryn och eyeliner, som framhäver dina drag och ger ett naturligt, långvarigt resultat. Vi arbetar med miljöverkets godkända färger för att garantera säkerhet och hög kvalitet."
    },
    {
      name: "Lashlift & Brow Lift",
      description: "Lyfta och forma dina fransar och ögonbryn för en naturligt vacker look"
    },
    {
      name: "Vaxning",
      description: "Professionell hårborttagning för en len och mjuk hud"
    },
    {
      name: "Elektrisk epilering",
      description: "En effektiv och permanent metod för att ta bort oönskad hårväxt i ansiktet. Behandlingen är noggrann och lämpar sig särskilt väl för mindre och känsliga områden, till exempel överläpp, haka och kinder."
    },
    {
      name: "Spray Tan",
      description: "Få en vacker, naturlig solbränna utan skadliga UV-strålar"
    },
    {
      name: "Pedikyr",
      description: "Komplett fotvård för vackra och välvårdade fötter"
    },
    {
      name: "Diatermi",
      description: "En effektiv metod för att ta bort ytliga blodkärl och xantelasma, med precisa och skonsamma resultat."
    }
  ];

  return (
    <div className="bg-white">
      {/* Hero */}
      <section 
        className="py-32 px-6 text-center relative overflow-hidden"
        style={{ background: 'linear-gradient(135deg, rgba(98, 195, 214, 0.1) 0%, rgba(211, 154, 84, 0.1) 100%)' }}
      >
        <div className="max-w-4xl mx-auto relative z-10">
          <h1 className="text-5xl md:text-6xl font-light mb-6 text-gray-800">
            Våra <span className="font-semibold" style={{ color: 'var(--primary)' }}>Behandlingar</span>
          </h1>
          <p className="text-xl text-gray-600 leading-relaxed">
            Upptäck vår omfattande meny av professionella skönhets- och hudvårdsbehandlingar
          </p>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <Sparkles className="w-12 h-12 mx-auto mb-4" style={{ color: 'var(--secondary)' }} />
            <h2 className="text-3xl md:text-4xl font-semibold mb-4" style={{ color: 'var(--secondary)' }}>
              Våra Tjänster
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Upptäck vårt utbud av professionella behandlingar.<br/>
              För fullständig beskrivning och aktuella priser, besök vår sida på bokadirekt eller kontakta oss - vi hjälper dig hitta det som passar dig bäst.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 border border-gray-100"
              >
                <h3 className="text-xl font-semibold mb-3 text-gray-800">{service.name}</h3>
                <p className="text-gray-600 leading-relaxed text-sm">{service.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a href="https://www.bokadirekt.se/places/salong-milepa-13263" target="_blank" rel="noopener noreferrer">
              <button 
                className="px-8 py-4 rounded-full text-lg font-semibold text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                style={{ backgroundColor: 'var(--primary)' }}
              >
                Visa behandlingar och priser
              </button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default React.memo(Treatments);